import React from "react";
import classnames from "classnames";
import { Parser } from "html-to-react";

const htmlParser = new Parser(React);

const LayoutText = props => {
  const { characters, text } = props;
  const textToRender = text?.length ? text : characters;
  const rawHtml = /<br>/.test(textToRender) ? textToRender : textToRender.replace(/(?:\r+\n|\r|\n)/g, "<br>");
  const renderSpans = spans =>
    spans.map((span, idx) => {
      const rawHtml = /<br>/.test(span.characters) ? span.characters : span.characters.replace(/(?:\r+\n|\r|\n)/g, "<br>");
      const text = htmlParser.parse(rawHtml);
      return (
        <span key={idx} style={span.styles}>
          {text}
        </span>
      );
    });

  return (
    <p
      id={props.id}
      className={classnames({
        [props.className]: props.className,
      })}
      style={props.styles}
    >
      {(props.spans?.length && renderSpans(props.spans)) || htmlParser.parse(rawHtml)}
    </p>
  );
};

export default LayoutText;
